import { render, staticRenderFns } from "./activityDeposit.vue?vue&type=template&id=674c1a58&scoped=true"
import script from "./activityDeposit.vue?vue&type=script&lang=js"
export * from "./activityDeposit.vue?vue&type=script&lang=js"
import style0 from "./activityDeposit.vue?vue&type=style&index=0&id=674c1a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c1a58",
  null
  
)

export default component.exports